export default {
  title: 'Ordrer',
};
